<header class="container-fluid" [ngClass]="{sticky: isSticky}">
  <a [routerLink]="['/']" class="logo">
    <h1 *ngIf="router.url === '/'">
      <img src="/assets/logo/se.png" alt="Salon Expert logo L'Oréal Professionnel" />
    </h1>
    <img *ngIf="router.url !== '/'" src="/assets/logo/se.png" alt="Salon Expert logo L'Oréal Professionnel" />
  </a>
  <button type="button" class="toggleMenu" [ngClass]="{ opened: toggleMenu }" (click)="toggleMenu = !toggleMenu"
    data-toggle="collapse" data-target="#menu-list" aria-controls="menu-list" [attr.aria-expanded]="toggleMenu"
    [attr.aria-label]="(toggleMenu ? 'Zwiń' : 'Rozwiń') + ' menu główne'">


    <!-- <svg *ngIf="!toggleMenu" style="height: 20px; width: 20px; margin-left: 15px;" class="icon" viewBox="0 0 512 512" ><use xlink:href="#bars" x="0" y="0" /></svg> -->
    <img *ngIf="!toggleMenu" src="/assets/headers/hamburger-icon-open.png" style="width: 41px; height: 23px" alt="hamburger menu icon">
    <svg *ngIf="toggleMenu" style="height: 20px; width: 20px; margin-left: 15px;" class="icon" viewBox="0 0 512 512" ><use xlink:href="#times" x="0" y="0" /></svg>

  </button>
  <nav [ngClass]="{show: toggleMenu}">
    <ul class="list1">
      <li class="dropdown" [ngClass]="{hover: showMenu1}" (mouseenter)="showMenu1 = true" (mouseleave)="showMenu1 = false;">
        <!-- <div class="text" (click)="showMenu1 = true">Porady & Inspiracje</div> -->
        <div class="dropdownMenu" [ngClass]="{show: showMenu1}">
          <div class="bg">
            <div class="mainHeader">
              Porady&nbsp;&&nbsp;Inspiracje
            </div>
            <div class="container-fluid" (mouseleave)="showMenu1 = false;">
              <div class="row">
                <div class="col-12 col-md-8">
                  <ul>
                    <li><a (click)="hideMenu()" [routerLink]="['/artykuly']" routerLinkActive="active">
                    <span>Artykuły</span></a></li>
                    <li><a (click)="hideMenu()" [routerLink]="['/salon-expert-tv']" routerLinkActive="active">
                        <span>Salon Expert TV</span></a></li>
                    <!-- <li><a (click)="hideMenu()" [routerLink]="['/lookbook-2019']" routerLinkActive="active">
                    <span>Lookbook 2019</span></a></li> -->
                  </ul>
                </div>
                <div class="col-12 col-md-3 article" *ngIf="article">
                  <app-article-box [link]="'/artykuly'" [article]="article"></app-article-box>
                </div>
              </div>
            </div>
          </div>

        </div>
      </li>
      <li class="dropdown" [ngClass]="{hover: showMenu2}" (mouseenter)="showMenu2 = true" (mouseleave)="showMenu2 = false;">
        <!-- <div class="text" (click)="showMenu2 = true">Produkty & Usługi</div> -->
        <div class="dropdownMenu" [ngClass]="{show: showMenu2}">
          <div class="bg">
            <div class="mainHeader">
              Produkty&nbsp;&&nbsp;Usługi
            </div>
            <div class="container-fluid" (mouseleave)="showMenu2 = false;">
              <div class="row">
                <div class="col-12 col-md-3">
                  <div class="header">
                    Produkty
                  </div>
                  <ul class="">
                    <ng-container *ngFor="let item of _lists.data.produkty">
                      <li>
                        <a (click)="hideMenu()" [routerLink]="['/produkty', item.slug]"
                          routerLinkActive="active">
                          <span>{{ item.name }}</span>
                        </a>
                      </li>
                    </ng-container>
                    <li>
                      <a (click)="hideMenu()" [routerLink]="['/produkty']" routerLinkActive="active">Wszystkie</a>
                    </li>
                  </ul>
                </div>
                <div class="col-12 col-md-3">
                  <div class="header">
                    Efekty
                  </div>
                  <ul>
                    <li>
                      <a (click)="hideMenu()" [routerLink]="['/zmiana-koloru']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                        <span>Zmiana koloru</span>
                      </a>
                    </li>
                    <li>
                      <a (click)="hideMenu()" [routerLink]="['/zmiana-koloru/koloryzacja-weganska']" routerLinkActive="active">
                        <span>Nabłyszczanie</span>
                      </a>
                    </li>
                    <li *ngFor="let item of _lists.data.efekty">
                      <a (click)="hideMenu()" [routerLink]="['/efekty', item.slug]" routerLinkActive="active">
                        <span>{{ item.name }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="col-12 col-md-3">
                  <div class="header">
                    Gamy
                  </div>
                  <ul>
                    <li *ngFor="let item of _lists.data.gamy">
                      <a (click)="hideMenu()" [routerLink]="['/gamy', item.slug]" routerLinkActive="active">
                        <span>{{ item.name }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="col-12 col-md-3 article">
                  <img src="../assets/diagnoza/diagnoza.webp?v=3" alt="Kobieta z rozpuszczonymi włosami" style="max-width: 100%;">
                  <p class="title"><strong>Diagnoza Włosa</strong></p>
                  <p>
                    Czy jesteś pewna, że używasz produktów odpowiednich dla Twoich włosów? Możesz to sprawdzić,
                    odpowiadając na kilka pytań. Poznaj produkty i usługi L’Oréal Professionnel odpowiadające na
                    potrzeby Twoich włosów.
                  </p>
                  <a (click)="hideMenu()" *ngIf="!diagnoza_res" [routerLink]="['/diagnoza']" class="btn">ROZPOCZNIJ</a>
                  <a (click)="hideMenu()" *ngIf="diagnoza_res" [routerLink]="['/diagnoza/wynik']" class="btn">SPRAWDŹ</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <!-- <ul class="list2">
      <li>
        <a class="text" (click)="hideMenu()" routerLink="/biznes">Dla Salonów</a>
      </li>
      <li>
        <a class="text" (click)="hideMenu()" routerLink="/diagnoza" routerLinkActive="active">Diagnoza włosów</a>
      </li>
    </ul> -->
    <ul class="list3">
      <li>
        <a [routerLink]="['/salon']" (click)="hideMenu()" class="btn btn--white"><svg style="height: 20px; width: 20px;" class="icon" viewBox="0 0 512 512" ><use xlink:href="#map-marker-alt" x="0" y="0" /></svg> Znajdź salon</a>
      </li>
      <li>
        <a [routerLink]="['/salon']" (click)="hideMenu()" [queryParams]="{ booksy: 'true' }" class="btn btn--booksy"></a>
      </li>
    </ul>
  </nav>
  <!-- <a class="search" (click)="hideMenu()" [routerLink]="['/szukaj']">
    <svg style="height: 20px; width: 20px;" class="icon" viewBox="0 0 512 512" ><use xlink:href="#search" x="0" y="0" /></svg>
  </a> -->
</header>
